import { useQuery } from '@tanstack/react-query';
import { getAgentService } from '../api/AgentApi';


export const useGetAgent = (uID) => {
    return useQuery({
      queryKey: ['agent', uID],
      queryFn: () => getAgentService(uID),
      enabled: !!uID, // chỉ gọi khi có uID
    });
  };
